import Modal from 'app/components/layouts/Modals/Index';
import { useTranslation } from 'next-i18next';

const ModalExamScore = ({ isOpen, onClose, handleExamScore, numberQuestionNotDone }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('tests.confirm_submit')}
      text={numberQuestionNotDone > 0 ? t('tests.warning_not_done', { number: numberQuestionNotDone }) : ''}
      confirmButtonText={t('commons.ok')}
      cancelButtonText={t('commons.cancel')}
      showCancelButton={true}
      show={isOpen}
      onClose={onClose}
      onConfirm={() => handleExamScore()}
    >
    </Modal>
  )
}

export default ModalExamScore
